import { useTranslation } from "@/providers/language-provider";
import { ThemeToggle } from "@/features/theme-toggle";
import { LanguageToggle } from "@/features/language-toggle";
import { AuthForm } from "@/features/auth-form";
import versionData from "@/version.json";

const appVersion = versionData.VERSION;
// const apiURL = import.meta.env.VITE_API_URL;

function AuthPage() {
  const { t } = useTranslation();

  return (
    <div className="app">
      <div className="w-full h-full flex flex-col">
        <div className="absolute left-4 top-4 md:left-8 md:top-8">
          <LanguageToggle />
        </div>
        <div className="absolute right-4 top-4 md:right-8 md:top-8">
          <ThemeToggle />
        </div>
        <div className="absolute left-1 bottom-0 text-xs text-muted-foreground">
          {appVersion}
          {/*, {apiURL} */}
        </div>

        <div className="lg:p-8 my-auto">
          <div className="mx-auto flex w-full flex-col justify-center items-center space-y-6 sm:w-[500px]">
            <div className="flex flex-col space-y-2 text-center">
              <h1 className="text-2xl font-semibold tracking-tight">
                {t("Title")}
              </h1>
              <p className="white text-sm text-muted-foreground">
                {t("TitleDesc")}
              </p>
            </div>
            <AuthForm />
            <p className="px-8 text-center text-sm text-muted-foreground">
              By clicking continue, you agree to our{" "}
              <a
                href="/terms"
                className="underline underline-offset-4 hover:text-primary"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                href="/privacy"
                className="underline underline-offset-4 hover:text-primary"
              >
                Privacy Policy
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthPage;
